import classNames from 'classnames';
import {useEffect} from 'react';
import {createPortal} from 'react-dom';
import {FCC} from 'types/react';

import {Icon} from 'components/Icon/Icon';

import styles from './Modal.module.css';

// Модалка рендерится через портал и поэтому выпадает из контейнера, в котором находится
// приложение. Для того чтобы навесить глобальные стили на модалку - задаем глобальный класс
const MODAL_GLOBAL_CLASSNAME = 'ModalComponent_LK';

type Props = {
    visible?: boolean;
    mobileViewEnabled?: boolean;
    className?: string;
    wrapperClassName?: string;
    closeClassName?: string;
    onClose?: () => void;
    onBack?: () => void;
};
export const Modal: FCC<Props> = ({
    children,
    visible,
    mobileViewEnabled,
    className,
    wrapperClassName,
    closeClassName,
    onClose,
    onBack,
}) => {
    useEffect(() => {
        if (visible) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
    }, [visible]);

    if (!visible) {
        return null;
    }

    return createPortal(
        <div
            className={classNames(
                MODAL_GLOBAL_CLASSNAME,
                styles.block,
                wrapperClassName,
                {
                    [styles.mobileView]: Boolean(mobileViewEnabled),
                },
            )}
        >
            <div className={styles.overlay} onClick={onClose || onBack} />
            <div className={classNames(styles.content, className)}>
                {children}
                {onClose && (
                    <div
                        className={classNames(styles.close, closeClassName)}
                        onClick={onClose}
                    >
                        <Icon name="cross" />
                    </div>
                )}
                {onBack && (
                    <div className={styles.back} onClick={onBack}>
                        <Icon name="back" />
                    </div>
                )}
            </div>
        </div>,
        document.body,
    );
};
